import { PayMonthOverviewViewModel, PayMonthStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';
import { HeadCellSortState } from '@foradevelopment/fora-ui';

import type { PayReportsTableSortId } from '../types';
import { sortStringBasic } from './comparisonFunctions';

type TableSortState = {
  [key in PayReportsTableSortId]?: HeadCellSortState;
};

export const sortPayMonthsListIndices = ({
  payMonthList,
  sortState,
  indices,
}: {
  /** An object where each key represents a report period and its value is an array of PayReport */
  payMonthList: PayMonthOverviewViewModel[];
  sortState: TableSortState;
  indices?: number[];
}): number[] => {
  let payReportsIndices: number[] = [];

  if (payMonthList) {
    payReportsIndices = Object.keys(payMonthList).map(key => Number(key));
  }
  if (Object.keys(sortState).every(state => state === HeadCellSortState.None)) {
    return indices ?? payReportsIndices;
  }

  // If indices is not empty, sort filtered pay reports
  const indicesToSort = indices ?? payReportsIndices;

  return indicesToSort.sort((a: number, b: number) => {
    const payMonthA = payMonthList[a];
    const payMonthB = payMonthList[b];

    const customStatusOrder: PayMonthStatusEnum[] = [
      PayMonthStatusEnum.ReportProcessing,
      PayMonthStatusEnum.ReportWithDeviations,
      PayMonthStatusEnum.NoActiveEmployments,
      PayMonthStatusEnum.ReportingNotDone,
      PayMonthStatusEnum.ReportingDelayed,
      PayMonthStatusEnum.ReportingApproved,
    ];

    // Default sorting by pay report status
    if (sortState.status) {
      const payMonthStatusA = payMonthA.payMonthStatus;
      const payMonthStatusB = payMonthB.payMonthStatus;
      if (payMonthStatusA || payMonthStatusB) {
        const indexA = customStatusOrder.indexOf((payMonthStatusA as PayMonthStatusEnum) ?? '');
        const indexB = customStatusOrder.indexOf((payMonthStatusB as PayMonthStatusEnum) ?? '');
        return indexA - indexB;
      }
    }

    // Sorting by reporting period
    if (sortState.reportingPeriods) {
      const reportingPeriodA = payMonthA.payMonth;
      const reportingPeriodB = payMonthB.payMonth;
      return sortStringBasic(
        reportingPeriodA ?? '',
        reportingPeriodB ?? '',
        sortState.reportingPeriods === HeadCellSortState.Asc
      );
    }

    return 0;
  });
};
